import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, Image } from 'antd';
import {  InfoCircleOutlined, CreditCardOutlined, AccountBookOutlined, CustomerServiceOutlined, SettingOutlined } from '@ant-design/icons';
import { useMediaQuery } from '@react-hook/media-query';
import './Sidenav.css';
import { AuthContext } from '../context/AuthContext';

function Sidenav({ toggleSidenav, setCurrentPage }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { user } = React.useContext(AuthContext);

  let selectedKey = '1';
  let currentPathname = location.pathname;
  switch (currentPathname) {
    case '/':
      selectedKey = '1';
      break;
    case '/airtime':
      selectedKey = '2';
      break;
    case '/account':
      selectedKey = '3';
      break;
    case '/transactions':
      selectedKey = '4';
      break;
    case '/transfer':
      selectedKey = '5';
      break;
    case '/bills':
      selectedKey = '6';
      break;
    case '/support':
      selectedKey = '7';
      break;
    case '/about':
      selectedKey = '8';
      break;
   case '/settings':
      selectedKey = '8';
      break;
    case '/contact':
      selectedKey = '9';
      break;
    default:
      selectedKey = '1';
  }

  // React.useEffect(() => {
  //   setCurrentPage(selectedKey);
  // }, [selectedKey, setCurrentPage]);

 const handleClick = (path) => {
  console.log("path", path);
  navigate(path, { state: { user } });
  if (isMobile && toggleSidenav) {
    toggleSidenav();
  }
};

  return (
    <Menu
      mode="inline"
      defaultSelectedKeys={[selectedKey]}
      defaultOpenKeys={['sub1']}
      className="sidenav"
    >
      <div className="logo-container" style={{ textAlign: 'center' }}>
        <Image
          width={80}
          src="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
          preview={false}
        />
      </div>
      <Menu.Item key="2" icon={<CreditCardOutlined />} onClick={() => handleClick("/airtime")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Airtime Topup</Menu.Item>
      <Menu.Item key="3" icon={<InfoCircleOutlined />} onClick={() => handleClick("/account")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Account Info</Menu.Item>
      <Menu.Item key="4" icon={<AccountBookOutlined />} onClick={() => handleClick("/transactions")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Transactions</Menu.Item>
      <Menu.Item key="5" icon={<CreditCardOutlined />} onClick={() => handleClick("/transfer")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Transfer Fund</Menu.Item>
      <Menu.Item key="6" icon={<CreditCardOutlined />} onClick={() => handleClick("/bills")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Pay Bills</Menu.Item>
      <Menu.Item key="7" icon={<CustomerServiceOutlined />} onClick={() => handleClick("/support")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Support</Menu.Item>
      <Menu.Item key="8" icon={<SettingOutlined />} onClick={() => handleClick("/settings")} style={{ color: '#333', marginBottom: '4px', fontWeight: '500' }}>Settings</Menu.Item>
    </Menu>
  );
}


export default Sidenav;
